import { Box, Container } from '@material-ui/core'
import React, { Component } from 'react'
import scriptLoader from 'react-async-script-loader'
import { connect } from 'react-redux'

import StickyContainer from '../components/common/StickyContainer'
import HomeDialogs from '../components/home/HomeDialogs'
import HomeSidebar from '../components/home/HomeSidebar'
import HomeLocationWidget from '../components/home/HomeLocationWidget'

import HomeSnackbars from '../components/home/HomeSnackbars'
import DeliverySettings from '../components/home/DeliverSettings'
import FeedbackLink from '../components/home/FeedbackLink'
import { MAPS_SCRIPT_URL } from '../components/location-search/LocationSearchBox'
import { loadDeliveryScheduleStart } from '../redux/modules/delivery'
import { addFavoritesForMenusStart } from '../redux/modules/favorite'
import { selectDateStart } from '../redux/modules/delivery'
import { loadOrderStart } from '../redux/modules/orderDetail'
import {
  selectCurrentLocationWithAddress,
  selectCurrentSavedLocation,
} from '../redux/modules/selectors'
import { isSelectedDeliveryDateActive } from '../redux/selectors/deliverySelectors'
import LayoutInnerPage from '../layouts/LayoutInnerPage'
import { loadOfficesStart } from '../redux/modules/offices'
import MobileWidgetSkeleton from '../components/home/MobileWidgetSkeleton'
import ManageOrderCard from '../components/home/ManageOrderCard'
import DailyDeliverySection from '../components/home/DailyDeliverySection'

class PageHomeNoFeatureFlags extends Component {
  render() {
    const {
      //redux
      activationDate,
      selectDateStart,
      currentSavedLocation,
      errorLoading,
      isAuthenticated,
      isLoadingDeliveries,
      isSelectedDayActive,
      location,
      orders,
      selectedDate,

      //props
      locationId,
      showManageOrder,
      sortedDeliveries,
      friendsOrdered,
      isDesktop,
      isScriptLoaded,
      isScriptLoadSucceed,
    } = this.props
    return (
      <>
        <LayoutInnerPage
          HeaderComponent={
            <>
              <MobileWidgetSkeleton
                isDesktop={isDesktop}
                loading={isLoadingDeliveries}
                WidgetComponent={HomeLocationWidget}
              />
              {showManageOrder && (
                <Box marginTop={3} marginBottom={5}>
                  <ManageOrderCard locationId={locationId} />
                </Box>
              )}
              <Container maxWidth="lg">
                <DeliverySettings
                  loading={isLoadingDeliveries}
                  selectDateStart={selectDateStart}
                  isScriptLoaded={isScriptLoaded}
                  isScriptLoadSucceed={isScriptLoadSucceed}
                  locationId={locationId}
                  name={
                    currentSavedLocation?.name ||
                    currentSavedLocation?.deliveryLocationName ||
                    location?.deliveryLocationName
                  }
                  orderCount={orders?.length}
                  selectedDate={selectedDate}
                />
              </Container>
            </>
          }
          MainComponent={
            <>
              <DailyDeliverySection
                showHeader={false}
                deliveries={sortedDeliveries}
                friendsOrdered={friendsOrdered}
                locationId={locationId}
                selectedDate={selectedDate}
                isSelectedDayActive={isSelectedDayActive}
                activationDate={activationDate}
                isLoadingDeliveries={isLoadingDeliveries}
                errorLoading={errorLoading}
              />

              {!isLoadingDeliveries && (
                <Box className="center-xs" marginTop={4}>
                  <FeedbackLink />
                </Box>
              )}
            </>
          }
          SidebarComponent={
            <StickyContainer stickyStyle={{ paddingTop: '50px' }} topOffset={-80}>
              {isAuthenticated && <HomeSidebar />}
              {!isAuthenticated && <HomeLocationWidget />}
            </StickyContainer>
          }
          headerContainerMaxWidth={false}
          hideSidebar="sm"
        />

        <HomeDialogs
          locationId={locationId}
          isScriptLoaded={isScriptLoaded}
          isScriptLoadSucceed={isScriptLoadSucceed}
        />
        <HomeSnackbars />
      </>
    )
  }
}

const mapStateToProps = state => {
  const { isLoadingDeliveries, selectedDate, errorLoading } = state.delivery
  const { isAuthenticated } = state.user
  const location = selectCurrentLocationWithAddress(state)
  const { location: { activationDate } = {} } = state.location
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { loading, orders } = state.orderDetail
  const { isWebpSupported } = state.browser
  const currentSavedLocation = selectCurrentSavedLocation(state)

  return {
    activationDate,
    currentSavedLocation,
    errorLoading,
    isAuthenticated,
    isLoadingDeliveries,
    isOrdersLoading: loading,
    isSelectedDayActive,
    isWebpSupported,
    location,
    orders,
    selectedDate,
  }
}

const mapDispatchToProps = {
  addFavoritesForMenusStart,
  selectDateStart,
  loadDeliveryScheduleStart,
  loadOrderStart,
  loadOfficesStart,
}

export default scriptLoader(MAPS_SCRIPT_URL)(
  connect(mapStateToProps, mapDispatchToProps)(PageHomeNoFeatureFlags),
)
